<!-- HTML del componente -->
<div *ngIf="isVisible && isCustomerUser()" class="overlay">  
    <div class="modal">
        <!-- Header Image -->
        <div class="modal-header">
            <img src="assets/img/complete-profile.jpg" alt="Completa tu perfil" class="header-image">
        </div>
        
        <!-- Content -->
        <div class="modal-content">
            <!-- Title -->
            <h2 class="modal-title">Completa tu perfil y potencia tu experiencia en Phoenix</h2>
            
            <!-- Description -->
            <p class="modal-description">
                Cada detalle que compartas nos ayudará <strong>a conocerte mejor</strong> y a ofrecerte acompañamiento, mentoría y oportunidades a tu medida. Dedica unos minutos a completar Tu Perfil ahora, ¡y desbloquea un recorrido más personalizado dentro de la comunidad!
            </p>
            
            <!-- Buttons -->
            <div class="modal-buttons">
                <button class="btn-secondary" (click)="closeDialog()">Cerrar</button>
                <button class="btn-primary" (click)="navigateToProfileView()">Ir a perfil</button>
            </div>
        </div>
    </div>
</div>